import React, { useRef } from 'react'
import ReactPlayer from 'react-player'
import PropTypes from 'prop-types'
import { allFileType } from './utils'
import fileImg from './assets/file_preview.png'
import ImagePreview from './ImagePreview'

const RenderTips = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full">
      <img src={fileImg} alt="" className="disabled-show" />
      <div className="flex items-center justify-center disabled-show-text">
        该文件格式暂不支持预览
      </div>
    </div>
  )
}

// 提取到utils
const checkFile = (url) => {
  const index = url.lastIndexOf('.')
  const endIndex = url.lastIndexOf('?')
  if (index > endIndex) {
    return url.slice(index + 1)
  }
  return url.slice(index + 1, endIndex)
}

const ShowFile = (props) => {
  const {
    currentFile,
    showWatermark,
    isShowWatermark,
    updateImg,
    isMark,
    setIsMark,
    setIsLoading,
  } = props
  const { src, srcWatermark, fileType, isdownload } = currentFile || {}
  const canvasElem = useRef()

  // 需根据格式判断
  const extension = fileType || checkFile(src)

  const type = allFileType.filter((obj) => {
    return (
      obj.extension.indexOf(extension) > -1 ||
      obj.extension.some((v) => extension.indexOf(v) > -1) ||
      extension.indexOf(obj.key) > -1
    )
  })
  const { key } = type[0] || {}

  if (key === 'image') {
    return (
      <div
        ref={canvasElem}
        className="relative w-full h-full flex flex-col items-center justify-center"
      >
        <ImagePreview
          src={src}
          srcWatermark={srcWatermark}
          currentFile={currentFile}
          showWatermark={showWatermark}
          isShowWatermark={isShowWatermark}
          updateImg={updateImg}
          isMark={isMark}
          setIsMark={setIsMark}
          setIsLoading={setIsLoading}
          // onImageMark={onImageMark}
        />
      </div>
    )
  }
  if (key === 'video') {
    // 暂不支持  3gp,avi,wmv格式
    const options = {}
    if (extension === 'm3u8') {
      options.config = {
        file: {
          forceHLS: true,
        },
      }
    }
    if (extension !== '3gp' && extension !== 'avi' && extension !== 'wmv') {
      return (
        <ReactPlayer
          className="react-player"
          url={src}
          playing
          controls
          {...options}
          width="100%"
          height="100%"
        />
      )
    }
    return <RenderTips />
  }

  if (key === 'audio') {
    if (extension !== 'wma') {
      return (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <audio controls>
          <source src={src} type="audio/mpeg" />
          <source src={src} type="audio/ogg" />
          <source src={src} type="audio/wav" />
        </audio>
      )
    }
    return <RenderTips />
  }
  if (key === 'doc' || key === 'xls') {
    return (
      // eslint-disable-next-line jsx-a11y/iframe-has-title
      <iframe
        src={`https://view.officeapps.live.com/op/view.aspx?src=${src}`}
        width="80%"
        height="600"
        frameBorder="1"
      />
    )
  }
  if (key === 'pdf') {
    const newLink = isdownload ? `${src}#toolbar=0&navpanes=0&scrollbar=0` : src
    // eslint-disable-next-line jsx-a11y/iframe-has-title
    return <iframe src={newLink} width="80%" height="600" frameBorder="1" />
  }
  if (key === 'zip' || key === 'txt') {
    return <RenderTips />
  }
  return null
}

ShowFile.propTypes = {
  currentFile: PropTypes.shape({}),
}

ShowFile.defaultProps = {
  currentFile: undefined,
}
export default ShowFile
